import { useCallback, useRef, useState } from 'react';

/**
 * Tracks an element's content height via ResizeObserver, exposed as a callback
 * ref so it re-measures correctly when the node mounts/unmounts — e.g. when the
 * add composer moves between the desktop inline bar and the mobile sheet.
 */
export const useMeasuredHeight = () => {
	const [height, setHeight] = useState(0);
	const observerRef = useRef<ResizeObserver | null>(null);

	const ref = useCallback((node: HTMLElement | null) => {
		observerRef.current?.disconnect();
		observerRef.current = null;
		if (!node) return;

		const measure = () => setHeight(node.scrollHeight);
		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(node);
		observerRef.current = observer;
	}, []);

	return { ref, height };
};
